import React, { useState } from 'react'
import { ReactComponent as SearchIcon } from 'assets/img/search-icon.svg'
import {
  StyledSearchInput,
  StyledSearch,
  StyledSearchIcon,
  StyledCloseIcon,
} from './SearchField.styles'
import { SearchFieldProps } from './SearchField.types'

function SearchField({ placeholder, value, setValue }: SearchFieldProps) {
  const [isSearchFieldOpened, setIsSearchFieldOpened] = useState(false)
  const [searchValue, setSearchValue] = useState(value)

  return isSearchFieldOpened ? (
    <StyledSearch>
      <SearchIcon />
      <StyledSearchInput
        autoFocus
        placeholder={placeholder}
        onChange={({ target: { value: inputValue } }) =>
          setSearchValue(inputValue)
        }
        onKeyDown={event => {
          if (event.key === 'Enter') {
            setValue(searchValue)
          }
        }}
        value={searchValue}
        disableUnderline
        onBlur={() => {
          if (!searchValue?.length) {
            setIsSearchFieldOpened(false)
          }

          setValue(searchValue)
        }}
      />
      {!!searchValue?.length && (
        <StyledCloseIcon
          onClick={() => {
            setIsSearchFieldOpened(false)
            setValue('')
            setSearchValue('')
          }}
        />
      )}
    </StyledSearch>
  ) : (
    <StyledSearchIcon
      role="button"
      onClick={() => setIsSearchFieldOpened(true)}>
      <SearchIcon />
    </StyledSearchIcon>
  )
}

export default SearchField
